import AvatarComponent from '@/components/common/avatar';
import { countFormatter } from '@/helpers/countHelper';
import useWidth from '@/helpers/widthUtil';
import { Skeleton } from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Card, CardBody } from 'reactstrap';

const AboutRoom = ({
  description,
  members_count,
  a_members,
  course,
  joined_date,
  room_type,
}) => {
  const { isMobile, isTablet } = useWidth();
  const loading = useSelector((state: any) => state.roomReducer.roomDetail?.loading);
  const sk = [1, 2, 3, 4];
  return (
    <>
      <Card className="col-lg-12 mt-4">
        <CardBody>
          <strong>
            About Group
            {(isMobile || isTablet) &&
              joined_date &&
              `( Joined On:{' '} ${moment(joined_date).format('Do MMM, YYYY')}} ) `}
          </strong>
          <hr />
          {loading ? (
            <Skeleton />
          ) : (
            <p className="text-justify mb-2">{description}</p>
          )}

          <div className="d-flex gap-3 align-items-center ">
            <>
              <i className="fas fa-list-ul"></i>
              <div className="d-flex align-items-center gap-3">
                <span
                  className="text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '600',
                  }}
                >
                  Type
                </span>
                <span
                  className="text-capitalize text-black"
                  style={{
                    fontSize: '15px',
                    fontWeight: '500',
                  }}
                >
                  {room_type === 0 ? 'Public' : room_type === 1 && 'Private'}
                </span>
              </div>
            </>
          </div>
        </CardBody>
      </Card>
      <Card className="col-lg-12">
        <CardBody>
          <strong>Members:{members_count}</strong>
          <hr />
          <div className="d-flex">
            {loading
              ? sk.map((each, k) => <Skeleton.Avatar key={k} className="ml-2" />)
              : a_members?.map((each, k) => (
                  <AvatarComponent
                    className="ml-2"
                    key={k}
                    avatar={each?.avatar}
                    firstName={each?.first_name}
                    lastName={each?.last_name}
                  />
                ))}
            {!loading && parseInt(members_count) - a_members?.length > 0 && (
              <span className="my-auto ml-2">
                +{countFormatter(parseInt(members_count) - a_members?.length)}
              </span>
            )}
          </div>
        </CardBody>
      </Card>
    </>
  );
};

export default AboutRoom;
